export const AUTH_TOKEN = 'QRkNtLqOaSj0zbJ_6sPg2A_si7_ElDbi';
